<template>
  <div class="main">
    <div class="menu">
      <main-menu />
    </div>
    <div class="content">
      <v-toolbar elevation="0">
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="$router.push('/profile')"
          class="themed"
        >{{user.firstname}} {{user.lastname}}</v-btn>
      </v-toolbar>
      <div class="view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from "./MainMenu.vue";
import { mapState } from "vuex";

export default {
  components: {
    MainMenu
  },
  computed: {
    ...mapState("auth", {
      user: state => state.user
    })
  }
};
</script>

<style lang="less">
html,
body {
  overflow: auto;
}
.main {
  display: flex;
  height: 100vh;
  .menu {
    flex: 0 0 270px;
    background-color: #0a252c;
  }
  .content {
    flex: 1 1 auto;
    box-sizing: border-box;
    background-color: #f5f5f5;
    overflow-y: auto;

    .view {
      padding: 20px;
    }
  }
}
</style>